<template>
  <div>
    <UnPatrolListComponent
      typeName="定期清掃 未完了一覧"
      :type="3"
      settionStrageName="FixedUnpatrolListStorageItemName">
    </UnPatrolListComponent>
  </div>
</template>

<script>
import UnPatrolListComponent from '../../Patrol/components/UnPatrolListComponent.vue'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    UnPatrolListComponent
  },
}
</script>